import React from "react";


const WarningIcon = ({ width, height, fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 50}
    height={height || 50}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill={fill || "#080341"}
      fillRule="evenodd"
      d="M19.5 12a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Zm1.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9.75 1.5V8.25h1.5v5.25h-1.5Zm0 2.25v-1.5h1.5v1.5h-1.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default WarningIcon;
